import { useRef, useState } from 'react'
import { Button } from '@campgladiator/cgui-core.atoms.button'
import { Icon } from '@campgladiator/cgui-core.atoms.icon'
import { Label, Paragraph } from '@campgladiator/cgui-core.atoms.typography'
import { Tooltip } from '@campgladiator/cgui-core.atoms.tooltip'
import { formatPhoneNumber } from '../../../../common/utility/strings'
import configuration from '../../../../configuration'
import { useOuterClick } from '../../../../common/hooks'
import {
  analytics,
  analyticsEvent,
  analyticsEventLabel,
} from '../../../../common/utility/analytics'
import { ActionPanelProps } from '../../TrainerBio.d'
import styles from './ActionPanel.module.scss'

const { trackCustomEvent } = analytics
const { BUTTON_CLICK, CLOSE, POPOVER } = analyticsEvent
const {
  TRAINER_BIO: {
    CONTACT_INFO,
    LOGIN_OR_SIGN_UP,
    SIGN_UP,
    LOGIN,
    CLOSE_POPOVER,
  },
} = analyticsEventLabel

const ActionPanel = ({
  isMobile,
  phoneNumber = '',
  isLoggedIn,
  onLoginClick,
  ...props
}: ActionPanelProps) => {
  const [showBtn, setShowBtn] = useState(true)
  const [showPopUp, setShowPopUp] = useState(false)

  const popUpRef = useRef<HTMLDivElement>(null)

  const hasPhoneNumber = !!phoneNumber
  const showViewContactBtn = showBtn && hasPhoneNumber

  const heading = 'Oops!'
  const text =
    'You’ll need to either log in or create an account before you can view a trainer’s contact information.'

  const handleViewContactClick = () => {
    trackCustomEvent(BUTTON_CLICK(CONTACT_INFO))
    if (isLoggedIn) {
      setShowBtn(false)
    } else {
      setShowPopUp(true)
      trackCustomEvent(POPOVER(LOGIN_OR_SIGN_UP))
    }
  }

  const handleModalBtnClick = () => {
    setShowPopUp(false)
    trackCustomEvent(CLOSE(CLOSE_POPOVER))
  }

  const handleLoginClick = () => {
    trackCustomEvent(BUTTON_CLICK(LOGIN))
    onLoginClick()
  }

  const handleSignUpClick = () => {
    trackCustomEvent(BUTTON_CLICK(SIGN_UP))
    window.open(configuration.pricingUrl, '_blank')
  }

  useOuterClick(popUpRef, () => {
    setShowPopUp(false)
  })

  return (
    <div className={styles.wrapper} ref={popUpRef} {...props}>
      {showViewContactBtn ? (
        <Button
          disabled={showPopUp}
          size={isMobile ? 'small' : 'default'}
          variation="outline"
          emphasis="secondary-alt"
          onClick={handleViewContactClick}
        >
          View Contact Info
        </Button>
      ) : (
        hasPhoneNumber && (
          <Label className={styles.label}>
            {formatPhoneNumber(phoneNumber)}
          </Label>
        )
      )}
      {showPopUp && (
        <Tooltip className={styles.toolTipWrapper} arrow="top" raised>
          <div className={styles.toolTip}>
            <div className={styles.toolTipText}>
              <Paragraph
                className={styles.toolTipHeader}
                size={isMobile ? 'default' : 'large'}
              >
                {heading}
              </Paragraph>
              <Paragraph weight="book">{text}</Paragraph>
            </div>
            <button className={styles.closeBtn} onClick={handleModalBtnClick}>
              <Icon name="icon-times-line" />
            </button>
          </div>
          <div className={styles.btnWrapper}>
            <Button variation="text" onClick={handleSignUpClick}>
              Sign Up
            </Button>
            <Button className={styles.loginBtn} onClick={handleLoginClick}>
              Login
            </Button>
          </div>
        </Tooltip>
      )}
      <Button
        className={styles.favoriteBtn}
        size={isMobile ? 'small' : 'default'}
        variation="outline"
        emphasis="secondary-alt"
        icon="icon-heart-line"
      />
    </div>
  )
}
export default ActionPanel
